export default "__VITE_ASSET__B6Apj_U9__"